import React, { useState } from 'react'

import { EuiFlyoutHeader, EuiFlyoutBody, EuiFlyoutFooter, EuiTitle, EuiButton, EuiFlexGroup, EuiFlexItem, EuiFormRow, EuiFieldText, EuiTextArea, EuiSpacer } from '@elastic/eui'
import AcFlyout from 'components/AcFlyout'

import { MarketChallenge } from 'api/interfaces/MarketAnalysis'
import BlueprintEditWarning from 'features/planner/components/BlueprintEditWarning'

interface EditMarketChallengeFlyoutProps {
  mode: 'add' | 'edit'
  challenge?: MarketChallenge
  onSave: (challenge: MarketChallenge) => void
  onClose: () => void
  isUpdating: boolean
  showBlueprintWarning?: boolean
}

const emptyChallenge: MarketChallenge = {
  title: '',
  severity: '',
  description: '',
  operationalImplications: ''
}

const EditMarketChallengeFlyout: React.FC<EditMarketChallengeFlyoutProps> = ({ mode, challenge, onSave, onClose, isUpdating, showBlueprintWarning = false }) => {
  const [formData, setFormData] = useState<MarketChallenge>(challenge ?? emptyChallenge)

  const handleSave = () => {
    onSave(formData)
  }

  const isSaveDisabled = !formData.title.trim()

  return (
    <AcFlyout onClose={onClose} size="l">
      <EuiFlyoutHeader>
        <EuiTitle size="m">
          <h2>{mode === 'add' ? 'Add Market Challenge' : `Edit ${formData.title}`}</h2>
        </EuiTitle>
      </EuiFlyoutHeader>
      <EuiFlyoutBody>
        <BlueprintEditWarning show={showBlueprintWarning} />
        <EuiFormRow label="Title" fullWidth>
          <EuiFieldText
            fullWidth
            value={formData.title}
            onChange={e => setFormData(prev => ({ ...prev, title: e.target.value }))}
          />
        </EuiFormRow>
        <EuiSpacer size="m" />
        <EuiFormRow label="Severity" fullWidth>
          <EuiFieldText
            fullWidth
            value={formData.severity}
            onChange={e => setFormData(prev => ({ ...prev, severity: e.target.value }))}
          />
        </EuiFormRow>
        <EuiSpacer size="m" />
        <EuiFormRow label="Description" fullWidth>
          <EuiTextArea
            fullWidth
            value={formData.description}
            onChange={e => setFormData(prev => ({ ...prev, description: e.target.value }))}
            rows={4}
          />
        </EuiFormRow>
        <EuiSpacer size="m" />
        <EuiFormRow label="Operational Implications" fullWidth>
          <EuiTextArea
            fullWidth
            value={formData.operationalImplications}
            onChange={e => setFormData(prev => ({ ...prev, operationalImplications: e.target.value }))}
            rows={4}
          />
        </EuiFormRow>
      </EuiFlyoutBody>
      <EuiFlyoutFooter>
        <EuiFlexGroup direction="row" alignItems="center">
          <EuiFlexItem grow={false}>
            <EuiButton onClick={onClose} isDisabled={isUpdating}>
              Cancel
            </EuiButton>
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiButton fill onClick={handleSave} isLoading={isUpdating} isDisabled={isSaveDisabled}>
              Save
            </EuiButton>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlyoutFooter>
    </AcFlyout>
  )
}

export default EditMarketChallengeFlyout
